import { render, staticRenderFns } from "./Alumini.vue?vue&type=template&id=64cc7f76&scoped=true&"
import script from "./Alumini.vue?vue&type=script&lang=js&"
export * from "./Alumini.vue?vue&type=script&lang=js&"
import style0 from "./Alumini.vue?vue&type=style&index=0&id=64cc7f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc7f76",
  null
  
)

export default component.exports